import { LoginPage } from "routes/login/LoginPage";
import { RouteConfig } from "./routeTypes";
import { AssistantPage } from "pages/assistant/AssistantPage";
import { JwtRequiredPage } from "routes/jwt-auth/JwtRequiredPage";

export const guestRouteConfig: RouteConfig[] = [
  {
    path: "/",
    component: LoginPage,
  },
  {
    path: "/jwt-auth-required",
    component: JwtRequiredPage,
  },
];

export const publicRouteConfig: RouteConfig[] = [];

export const protectedRouteConfig: RouteConfig[] = [
  {
    path: "/assistant",
    component: AssistantPage,
    subscriptionOnly: true,
  },
  {
    path: "/assistant/:threadId",
    component: AssistantPage,
    subscriptionOnly: true,
  },
];
